export const environment = {
  production: true,
  configFile: 'assets/config/config.json',
  version: '2026-02-24.02',
};
